import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import {
  browserLocalPersistence,
  createUserWithEmailAndPassword,
  sendEmailVerification,
  setPersistence,
} from "firebase/auth";
import loginbg from "../../assets/techbg.jpg";
import { auth, db, get, ref, set } from "../../utilities/firebaseConfig";
import { Eye, EyeOff } from "lucide-react";

function TechnicianSignuppage() {
  const [email, setEmail] = useState("");
  const [name, setName] = useState("");
  const [password, setPassword] = useState("");
  const [lastName, setLastName] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [successMessage, setSuccessMessage] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [bio, setBio] = useState(true);
  const navigate = useNavigate();


  
  const handleSignup = async (e) => {
    e.preventDefault();
    setBio(true);

    if (!name || !lastName || !email || !password) {
      setErrorMessage("All fields are required");
      return;
    }

    try {
      await setPersistence(auth, browserLocalPersistence);
      const userCredential = await createUserWithEmailAndPassword(
        auth,
        email,
        password
      );
      const user = userCredential.user;

      // Save user data
      await set(ref(db, `technicians/${user.uid}`), {
        name,
        lastName,
        email,
        role: "technician",
        approval: "pending",
        rating: 5,
        bio,
        createdAt: Date.now(),
      });

      // Send email verification
      await sendEmailVerification(user);
      setSuccessMessage(
        "Signup successful! Please check your email to verify your account."
      );

      // Optionally redirect after delay
      setTimeout(() => {
        navigate("/verify-email");
      }, 3000);
    } catch (error) {
      console.error("Signup error:", error.message);
      setErrorMessage(error.message);
    }
  };
  const [openMenu, setOpenMenu] = useState(true);
  const [isVisible, setIsVisible] = useState(true);
  const [lastScrollY, setLastScrollY] = useState(0);

  const handleScroll = () => {
    const currentScrollY = window.scrollY;

    if (currentScrollY <= 0) {
      // Always show navbar at the top of the page
      setIsVisible(true);
    } else if (currentScrollY > lastScrollY) {
      // Scrolling down
      setIsVisible(false);
    } else if (currentScrollY < lastScrollY) {
      // Scrolling up
      setIsVisible(true);
    }

    setLastScrollY(currentScrollY);
  };

  useEffect(() => {
    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, [handleScroll, lastScrollY]);

  return (
    <div className='authbody'>
      <div className='authspagecnt'>
        <div className='signin_cnt'>
          <Link to='/' className='profixlogo'>
            ProfixExpress
          </Link>

          <div className='signincntbdy'>
            <div className='signin_cnt'>
              <h2 className='signin_title'>
                Become part of us and Start Earning smoothly,
              </h2>
              <div className='thespace'></div>
              <p className='dnthaacnt'>
                Already have an account?{" "}
                <span onClick={() => navigate("/login")}>Log in</span>
              </p>
              <div className='thespacee'></div>
              {errorMessage && <p style={{ color: "red" }}>{errorMessage}</p>}
              {successMessage && (
                <p style={{ color: "green" }}>{successMessage}</p>
              )}
              <div className='thespacee'></div>
              <form onSubmit={handleSignup}>
                <div className='thedive'>
                  <div className='inputcnt'>
                    <input
                      type='text'
                      placeholder='First Name'
                      value={name}
                      onChange={(e) => setName(e.target.value)}
                    />
                  </div>
                  <div className='inputcnt'>
                    <input
                      type='text'
                      placeholder='Last Name'
                      value={lastName}
                      onChange={(e) => setLastName(e.target.value)}
                    />
                  </div>
                </div>

                <div className='inputcnt'>
                  <input
                    type='email'
                    placeholder='Email Address'
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                  />
                </div>
                <div className='inputcnt' style={{ position: "relative" }}>
                  <input
                    type={showPassword ? "text" : "password"}
                    placeholder='Password'
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    required
                    style={{
                      width: "100%",
                      paddingRight: "40px", // leave space for the icon
                    }}
                  />
                  <span
                    onClick={() => setShowPassword(!showPassword)}
                    style={{
                      position: "absolute",
                      right: "10px",
                      top: "50%",
                      transform: "translateY(-50%)",
                      cursor: "pointer",
                      color: "#666",
                    }}
                  >
                    {showPassword ? <EyeOff size={18} /> : <Eye size={18} />}
                  </span>
                </div>

                <div className='thenewsletter'>
                  <input type='checkbox' />
                  <label htmlFor='' className='thejoinn'>
                    Join our email list for special offers and updates!
                  </label>
                </div>
                <div className='thespace'></div>

                <p className='signupagreement'>
                  By creating account I agree with Profixexpress's
                  <span> Privacy policy</span> and{" "}
                  <span>Terms of service.</span>
                </p>
                <button className='thesigninbtn' type='submit'>
                  Create account
                </button>
              </form>
            </div>
          </div>
        </div>
        <div className='sigininimagecnt'>
          <img className='signiimg' src={loginbg} alt='' />
        </div>
      </div>
    </div>
  );
}

export default TechnicianSignuppage;
